export default __webpack_public_path__ + "static/media/Transaction.e2cac73f.svg";